export const SET_USER_AND_NOTIFICATION_TYPES =
  'SET_USER_AND_NOTIFICATION_TYPES';
export const FTCH_USER_AND_NOTIFICATION_TYPES =
  'FTCH_USER_AND_NOTIFICATION_TYPES';
export const MODIFY_USER_AND_NOTIFICATION_TYPES =
  'MODIFY_USER_AND_NOTIFICATION_TYPES';
export const DELETE_USER_AND_NOTIFICATION_TYPES =
  'DELETE_USER_AND_NOTIFICATION_TYPES';
